import {
  Component,
  EventEmitter,
  OnInit,
  ElementRef,
  Output,
  ViewChild,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SidebarStateService } from "src/app/services/sidebar-state.service";
import { CommonService } from "src/app/services/common.service";
import { ChatService } from "src/app/services/chat.service";
import { environment } from "src/environments/environment";
import { FileuploadService } from "src/app/services/fileupload.service";

declare var $: any;
declare const closeAllSockets: any;
declare function googleTranslate(): any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  @Output() superMaduleEvent = new EventEmitter<any>();
  userName: string =
    (localStorage.getItem("Username")?.toUpperCase() || "") +
    " " +
    (sessionStorage.getItem("lastname")?.toUpperCase() || "");
  roleName: string = localStorage.getItem("RoleName") || "";
  applicantId = localStorage.getItem("IsApplicant");
  table: Array<any> = [];
  viewMsg: Array<any> = [];
  message: Array<any> = [];
  levelUpdate: any;
  notifications: Array<any> = [];
  notification: any;
  viewNoti: Array<any> = [];
  OPERATION: any;
  ROLEID = localStorage.getItem("RoleId");
  myForm: any = UntypedFormGroup;
  oldPassword: any;
  chatMessage: any = "";
  chatMessagesList: any = [];
  differnceTime: any;
  startTime: any = new Date();
  endtime: any = new Date();
  patient_id: any;
  existingsname: any;
  studentArray: any = [];
  student_id: any;
  property: string = "";
  TeachersCount: any;
  onlineTeachers: any;
  notificationCount: any;
  loginDetails: any = {
    member: "Student",
    trainer: "Trainer",
    admin: "Admin",
    admin1: "Administrator L1",
    admin2: "Administrator L2",
    applicantMember: "Applicant",
  };
  isExpanded: boolean = false;
  isWaterAnimationActive: boolean = false;
  userDetails: any;
  url: string = environment.videoUrl;
  roles: Array<any> = [];
  selectRole: string = "";
  selectedModule: any = "1";
  profileDetails: any = "";
  previewUrl: any;
  file: any = File;
  fileName: string = "";
  imageName: string = "";
  @ViewChild("fileInputRef") fileInputRef: any = ElementRef;
  @ViewChild("fileInputRef1") fileInputRef1: any = ElementRef;
  SchoolList: Array<any> = [];
  SchoolLevelId = localStorage.getItem("schoolLevelID") || 0;
  dashboardPath: any = sessionStorage.getItem("dashboard_path");

  // Edit Institution Properties
  editData: any = {};
  originalData: any = {};
  isUpdating: boolean = false;
  userId: number = parseInt(localStorage.getItem("UserId") || "0");
  County: Array<any> = [];
  subCounty: Array<any> = [];
  Constituency: Array<any> = [];
  categories: any[] = [];
  sneCategoriesList: any[] = [];
  selectedSneDetails: any[] = [];
  subSneCategoriesList: any[] = [];
  selectedSubSneDetails: any[] = [];
  showSubSneDropdown: boolean = false;
  updateLogs: any[] = [];

  // Stored values for institution type change
  storedBoysCapacity: number = 0;
  storedSneBoysCapacity: number = 0;
  storedGirlsCapacity: number = 0;
  storedSneGirlsCapacity: number = 0;
  previousInstitutionType: number = 0;

  // File upload
  certificateFileToUpload: File | null = null;
  InstitutionRegCertificate: string = "";

  dropdownSettings: any = {};
  subDropdownSettings: any = {};

  // Flags for preventing selection changes
  private isRevertingSelection: boolean = false;
  private originalSneDetails: any[] = [];
  private originalSubSneDetails: any[] = [];

  constructor(
    private route: Router,
    private chatService: ChatService,
    private CommonService: CommonService,
    private fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private sidebarStateService: SidebarStateService,
    private FileuploadService: FileuploadService,
  ) {
    this.CommonService.decrypt$(
      localStorage.getItem("RoleId") || "0",
    ).subscribe((value) => {
      this.ROLEID = value;
    });

    this.sidebarStateService.isExpanded$.subscribe((isExpanded) => {
      this.isExpanded = isExpanded;
    });

    // this.loadMessage();
    // this.getOldPassword();
    // this.ROLEID = await this.CommonService.decryptAesGcm(
    //       localStorage.getItem("RoleId") || "0",
    //       this.CommonService.secretKey,
    //     );
    if (this.ROLEID == "3") {
      if (this.applicantId === "1") {
        this.roleName = this.loginDetails.applicantMember;
      } else {
        this.roleName = this.loginDetails.member;
      }
    } else if (this.ROLEID == "2") {
      this.roleName = this.loginDetails.trainer;
    } else if (this.ROLEID == "1") {
      this.roleName = this.loginDetails.admin;
    } else if (this.roleName == "Academic L1") {
      this.roleName = this.loginDetails.admin1;
    } else if (this.roleName == "Academic L2") {
      this.roleName = this.loginDetails.admin2;
    }
  }

  async decryptionRoleId() {
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId") as any,
      this.CommonService.secretKey,
    );
    this.decryptionRoleId = decryptedValue;
  }

  private iniForm() {
    this.myForm = this.fb.group({
      oldPassword: ["", [Validators.required, Validators.minLength(6)]],
      password: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
        ],
      ],
      confirmPassword: ["", [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit() {
    this.decryptionRoleId();
    this.iniForm();

    // Initialize dropdown settings
    this.dropdownSettings = {
      singleSelection: false,
      idField: "SNE_CATEGORY_ID",
      textField: "SNE_CATEGORY_NAME",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: false,
      limitSelection: -1,
      badgeShowLimit: 3,
    };

    this.subDropdownSettings = {
      singleSelection: false,
      idField: "SNE_SUBCATEGORY_ID",
      textField: "SNE_SUBCATEGORY_NAME",
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: false,
      limitSelection: -1,
      badgeShowLimit: 3,
    };

    this.CommonService.decrypt$(
      localStorage.getItem("RoleId") || "0",
    ).subscribe((value) => {
      this.selectedModule = value;
    });
    this.superMaduleEvent.emit(this.selectedModule);
    this.loadingToggled();
    // this.getUserProfile();
    this.getRoles();
    if (![1, 2, 3, 4, 9, 10].includes(Number(this.ROLEID))) {
      this.getSchool();
    }

    // this.getSchoolCategories();
    // this.loadProfileLogo();
  }

  async ConvertRoleId() {
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId") || "0",
      this.CommonService.secretKey,
    );
    this.ROLEID = decryptedValue;
  }

  getUserProfile() {
    this.CommonService.postCall("Registration/GetAudioPath", {
      USERID: localStorage.getItem("UserId"),
      COURSE_ID: localStorage.getItem("CourseId"),
    }).subscribe((res: any) => {
      this.userDetails = res;
    });
  }

  loadProfileLogo() {
    this.CommonService.getCall(
      `TenantRegistration/GetProfileScreenForInstitutes/${localStorage.getItem("TenantCode")}`,
    ).subscribe((res: any) => {
      this.profileDetails = res;
      this.fileName = this.profileDetails?.tnt_logo;
      this.previewUrl = this.getImage();
    });
  }

  LoadProfileDetails() {
    this.getSchool();
    this.countyDropdowns();
    this.countyDropdowns();
    this.loadProfileLogo();
    if (this.ROLEID == "1") {
      this.profileDetails = "";
      this.CommonService.getCall(
        `TenantRegistration/GetProfileScreenForInstitutes/${localStorage.getItem("TenantCode")}`,
      ).subscribe((res: any) => {
        this.profileDetails = res;
        this.fileName = this.profileDetails.tnt_logo;
        this.previewUrl = this.getImage();
        this.loadInstitutionForEdit();
      });
    }
  }

  // Load institution data for editing
  loadInstitutionForEdit() {
    this.activeSpinner();
    this.CommonService.postCall("TenantRegistration/GetTenantbyId", {
      TNT_CODE: localStorage.getItem("TenantCode"),
    }).subscribe(
      (res: any) => {
        this.editData = JSON.parse(JSON.stringify(res));
        this.originalData = JSON.parse(JSON.stringify(res));

        // Initialize stored values
        this.storedBoysCapacity = this.editData.tnt_boys_capacity || 0;
        this.storedSneBoysCapacity = this.editData.tnt_sne_boyscapacity || 0;
        this.storedGirlsCapacity = this.editData.tnt_girls_capacity || 0;
        this.storedSneGirlsCapacity = this.editData.tnt_sne_girlscapacity || 0;
        this.previousInstitutionType = this.editData.institution_type || 0;

        this.initializeEditDataDefaults();
        this.getSchoolCategories();

        if (
          this.editData.school_category_id &&
          ["2", "3", "4"].includes(this.editData.school_category_id.toString())
        ) {
          this.getSneCategoryList(this.editData.school_category_id.toString());
        }

        if (
          this.editData.TNT_CONCURRENT_AVSESSIONS &&
          this.editData.TNT_CONCURRENT_AVSESSIONS != 0
        ) {
          this.subCounties(this.editData.TNT_CONCURRENT_AVSESSIONS);
        }

        this.calculateTotalLearners();
        this.deactivateSpinner();

        setTimeout(() => {
          $("#editInstitutionModal").modal("show");
        }, 100);
      },
      (e) => {
        this.deactivateSpinner();
        this.toastr.error("Failed to load institution data for editing");
      },
    );
  }

  initializeEditDataDefaults() {
    const defaults = {
      TNT_NAME: "",
      TNT_DESCRIPTION: "",
      TNT_CONCURRENT_AVSESSIONS: "",
      TNT_USERSPERSESSION: "",
      email: "",
      mobileno: "",
      schoollocation: "",
      schoollevel: "",
      TNT_PARENT_CODE: null,
      SHOWLOGO: false,
      allow_proctoring: false,
      allow_exampad: false,
      constituency: "",
      simba_acc: "",
      gpa_accno: "",
      bankbranch: "",
      bankname: "",
      noofnonteaching_female: 0,
      noofnonteaching_male: 0,
      noofteaching_female: 0,
      noofteaching_male: 0,
      noofteaching_total: 0,
      noofnonteaching_total: 0,
      learnerenrolment_total: 0,
      accommodation_type: "",
      gpi: "0",
      landmark: "",
      applicationtype: "",
      registration_no: "",
      tnt_sne_capacity: 0,
      tnt_registration_certificate: "",
      tnt_boys_capacity: 0,
      tnt_girls_capacity: 0,
      tnt_sne_boyscapacity: 0,
      tnt_sne_girlscapacity: 0,
      school_regno: "",
      enrollment_boys: 0,
      enrollment_girls: 0,
      schoolnameincertificate: "",
      latitude: "",
      longitude: "",
      sne_disabilitytype_otherdescription: "",
      reregistration_reasons: 0,
      institution_type: "",
      subscriptionid: 35,
      mobilenocode_countryid: "336",
      mobilenocode_countryName: null,
      is_valid_certificate: false,
      TNT_CREATEDBY: null,
      TNT_KEY: "",
      school_category_id: "",
      sne_category_id: "",
      sne_subcategory_id: "",
      registration_type: 1,
      TNT_STATUS: true,
      TenantLogoUrl: "",
      institution_level: "",
      counties_id: 0,
      sub_counties_name: "",
      counties_name: "",
      con_counties_name: "",
      TNT_MODIFIEDBY: this.userId,
      TNT_CODE: localStorage.getItem("TenantCode") || "",
    };

    for (const key in defaults) {
      if (this.editData[key] === undefined || this.editData[key] === null) {
        this.editData[key] = defaults[key];
      }
    }
  }

  countyDropdowns() {
    this.County = [];
    this.CommonService.postCall("ClustersMaster/GetCountiesListByKenya", {
      COUNTRY_NAME: "Kenya",
    }).subscribe(
      (res: any) => {
        this.County = res;
        this.County = this.County.filter((x) => x.STATUS == true);
      },
      (err: any) => {
        return this.toastr.error(err.error ? err.error : "No County's found!");
      },
    );
  }

  subCounties(SubCountyId: any) {
    this.subCounty = [];
    this.CommonService.postCall("ClustersMaster/GetSubCountiesList", {
      counties_id: SubCountyId,
    }).subscribe(
      (res: any) => {
        this.subCounty = res;
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error : "No Sub-County's found!");
      },
    );
    this.CommonService.postCall("ClustersMaster/GetCountyconstituenciesList", {
      counties_id: SubCountyId,
    }).subscribe(
      (res: any) => {
        this.Constituency = res;
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error : "No Constituency found!");
      },
    );
  }

  getSchoolCategories() {
    this.categories = [];
    this.CommonService.postCall(
      "TenantRegistration/GetSchoolCategoryList",
      {},
    ).subscribe(
      (res: any) => {
        this.categories = res;
      },
      (err: any) => {
        console.error("Error loading categories:", err);
      },
    );
  }

  getSneCategoryList(categoryId: string) {
    this.activeSpinner();
    this.sneCategoriesList = [];
    this.selectedSneDetails = [];

    this.CommonService.postCall("TenantRegistration/GetSneCategoryList", {
      SCHOOL_CATEGORY_ID: categoryId,
    }).subscribe(
      (res: any) => {
        this.sneCategoriesList = res;
        if (this.editData?.sne_category_id) {
          const existingIds = this.editData.sne_category_id.split(",");
          this.selectedSneDetails = this.sneCategoriesList.filter((item: any) =>
            existingIds.includes(item.SNE_CATEGORY_ID.toString()),
          );
          // Store original selections for read-only protection
          this.originalSneDetails = JSON.parse(
            JSON.stringify(this.selectedSneDetails),
          );
          this.onSneDetailChange();
        }
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
        console.error("Error loading SNE categories:", err);
      },
    );
  }

  getSubSneCategoryList(categoryIds: number[]) {
    this.activeSpinner();
    this.subSneCategoriesList = [];

    this.CommonService.postCall("TenantRegistration/GetSubSneCategoryList", {
      SNE_CATEGORY_IDS: categoryIds.join(","),
    }).subscribe(
      (res: any) => {
        this.subSneCategoriesList = res;
        if (this.editData?.sne_subcategory_id) {
          const existingSubIds = this.editData.sne_subcategory_id.split(",");
          this.selectedSubSneDetails = this.subSneCategoriesList.filter(
            (item: any) =>
              existingSubIds.includes(item.SNE_SUBCATEGORY_ID.toString()),
          );
          // Store original selections for read-only protection
          this.originalSubSneDetails = JSON.parse(
            JSON.stringify(this.selectedSubSneDetails),
          );
        }
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
        console.error("Error loading sub categories:", err);
      },
    );
  }

  onSneDetailChange(event?: any) {
    // Prevent infinite loop
    if (this.isRevertingSelection) {
      return;
    }

    // Check if selection changed from original
    const currentIds = this.selectedSneDetails
      .map((x) => x.SNE_CATEGORY_ID)
      .sort();
    const originalIds = this.originalSneDetails
      .map((x) => x.SNE_CATEGORY_ID)
      .sort();

    if (JSON.stringify(currentIds) !== JSON.stringify(originalIds)) {
      // Selection changed - revert it
      this.isRevertingSelection = true;
      this.selectedSneDetails = JSON.parse(
        JSON.stringify(this.originalSneDetails),
      );

      this.toastr.warning(
        "Integrated categories are read-only and cannot be modified",
        "Read Only",
        {
          timeOut: 2000,
          closeButton: true,
        },
      );

      this.isRevertingSelection = false;
      return;
    }

    // Process sub-category dropdown logic (only if no change was made)
    const targetIds = ["12", "13", "17"];
    const matchedIds = this.selectedSneDetails
      .map((x: any) => x.SNE_CATEGORY_ID?.toString())
      .filter((id: string) => targetIds.includes(id))
      .map((id) => +id);

    if (matchedIds.length > 0) {
      this.showSubSneDropdown = true;
      this.getSubSneCategoryList(matchedIds);
    } else {
      this.showSubSneDropdown = false;
      this.subSneCategoriesList = [];
      this.selectedSubSneDetails = [];
      this.originalSubSneDetails = [];
    }
  }

  onSubSneDetailChange(event?: any) {
    // Prevent infinite loop
    if (this.isRevertingSelection) {
      return;
    }

    // Check if selection changed from original
    const currentIds = this.selectedSubSneDetails
      .map((x) => x.SNE_SUBCATEGORY_ID)
      .sort();
    const originalIds = this.originalSubSneDetails
      .map((x) => x.SNE_SUBCATEGORY_ID)
      .sort();

    if (JSON.stringify(currentIds) !== JSON.stringify(originalIds)) {
      // Selection changed - revert it
      this.isRevertingSelection = true;
      this.selectedSubSneDetails = JSON.parse(
        JSON.stringify(this.originalSubSneDetails),
      );

      this.toastr.warning(
        "Sub categories are read-only and cannot be modified",
        "Read Only",
        {
          timeOut: 2000,
          closeButton: true,
        },
      );

      this.isRevertingSelection = false;
      return;
    }
  }

  shouldShowIntegratedField(): boolean {
    const categoryId = this.editData?.school_category_id;
    return categoryId && ["2", "3", "4"].includes(categoryId.toString());
  }

  onCountyChange(event: any) {
    const countyId = event.target.value;
    if (countyId && countyId != 0) {
      this.subCounties(countyId);
      this.editData.TNT_CONCURRENT_AVSESSIONS = countyId;
    } else {
      this.subCounty = [];
      this.Constituency = [];
    }
  }

  onSubCountyChange(event: any) {
    const subCountyName = event.target.value;
    this.editData.TNT_USERSPERSESSION = subCountyName;
  }

  onConstituencyChange(event: any) {
    const constituencyName = event.target.value;
    this.editData.constituency = constituencyName;
  }

  onSchoolCategoryChange(event: any) {
    const categoryId = event.target.value;
    if (categoryId && ["2", "3", "4"].includes(categoryId)) {
      this.getSneCategoryList(categoryId);
    } else {
      this.sneCategoriesList = [];
      this.selectedSneDetails = [];
      this.originalSneDetails = [];
      this.showSubSneDropdown = false;
      this.subSneCategoriesList = [];
      this.selectedSubSneDetails = [];
      this.originalSubSneDetails = [];
    }
  }

  calculateTotalLearners() {
    const boys = parseFloat(this.editData.tnt_boys_capacity) || 0;
    const sneBoys = parseFloat(this.editData.tnt_sne_boyscapacity) || 0;
    const girls = parseFloat(this.editData.tnt_girls_capacity) || 0;
    const sneGirls = parseFloat(this.editData.tnt_sne_girlscapacity) || 0;

    const total = boys + sneBoys + girls + sneGirls;
    this.editData.tnt_sne_capacity = total;
  }

  onInstitutionTypeChange() {
    const newType = this.editData.institution_type;

    if (
      this.previousInstitutionType == 1 ||
      this.previousInstitutionType == 3
    ) {
      this.storedBoysCapacity = this.editData.tnt_boys_capacity || 0;
      this.storedSneBoysCapacity = this.editData.tnt_sne_boyscapacity || 0;
    }

    if (
      this.previousInstitutionType == 2 ||
      this.previousInstitutionType == 3
    ) {
      this.storedGirlsCapacity = this.editData.tnt_girls_capacity || 0;
      this.storedSneGirlsCapacity = this.editData.tnt_sne_girlscapacity || 0;
    }

    if (newType == 1) {
      this.editData.tnt_boys_capacity = this.storedBoysCapacity;
      this.editData.tnt_sne_boyscapacity = this.storedSneBoysCapacity;
      this.editData.tnt_girls_capacity = 0;
      this.editData.tnt_sne_girlscapacity = 0;
    } else if (newType == 2) {
      this.editData.tnt_boys_capacity = 0;
      this.editData.tnt_sne_boyscapacity = 0;
      this.editData.tnt_girls_capacity = this.storedGirlsCapacity;
      this.editData.tnt_sne_girlscapacity = this.storedSneGirlsCapacity;
    } else if (newType == 3) {
      this.editData.tnt_boys_capacity = this.storedBoysCapacity;
      this.editData.tnt_sne_boyscapacity = this.storedSneBoysCapacity;
      this.editData.tnt_girls_capacity = this.storedGirlsCapacity;
      this.editData.tnt_sne_girlscapacity = this.storedSneGirlsCapacity;
    }

    this.previousInstitutionType = newType;
    this.calculateTotalLearners();
  }

  changeFileForMultiple(event: any, type: number) {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.type;
      const fileSize = file.size / (1024 * 1024);

      if (fileType !== "application/pdf") {
        this.toastr.warning("File must be in PDF format only");
        if (this.fileInputRef1) {
          this.fileInputRef1.nativeElement.value = "";
        }
        return;
      }

      if (fileSize > 8) {
        this.toastr.warning("File size must be less than 8MB");
        if (this.fileInputRef1) {
          this.fileInputRef1.nativeElement.value = "";
        }
        return;
      }

      this.certificateFileToUpload = file;
      this.uploadFile(type);
    }
  }

  uploadFile(type: number) {
    if (!this.certificateFileToUpload) return;

    this.activeSpinner();

    const formData = new FormData();
    formData.append("upload_1", this.certificateFileToUpload);
    formData.append("DIRECTORY_NAME", "institutionDocuments");

    this.FileuploadService.upload(
      formData,
      "Registration/UploadTenantRegistrationFile",
    ).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        const uploadedPath = res.path;
        this.InstitutionRegCertificate = uploadedPath;
        this.editData.tnt_registration_certificate = uploadedPath;
        this.toastr.success("File uploaded successfully");
      },
      (err) => {
        this.deactivateSpinner();
        this.toastr.error("Upload Failed");
      },
    );
  }

  getFileUrl(path: string): string {
    return path;
  }

  // Load update logs for the institution
  loadUpdateLogs() {
    this.activeSpinner();
    this.CommonService.postCall("TenantRegistration/GetTenantUpdateLogs", {
      TNT_CODE: localStorage.getItem("TenantCode"),
    }).subscribe(
      (res: any) => {
        this.updateLogs = res || [];
        this.deactivateSpinner();
      },
      (err) => {
        this.deactivateSpinner();
        console.error("Error loading update logs:", err);
        this.updateLogs = [];
      },
    );
  }

  getFieldDisplayName(fieldName: string): string {
    const fieldNames: { [key: string]: string } = {
      TNT_NAME: "Institution Name",
      email: "Email",
      mobileno: "Mobile Number",
      institution_type: "Institution Type",
      tnt_boys_capacity: "Number of Boys Learners",
      tnt_girls_capacity: "Number of Girls Learners",
      tnt_sne_boyscapacity: "Number of SNE Boys",
      tnt_sne_girlscapacity: "Number of SNE Girls",
      tnt_sne_capacity: "Total Number of Learners",
      accommodation_type: "Accommodation Type",
      registration_no: "Registration Number",
      tnt_registration_certificate: "Registration Certificate",
      TNT_CONCURRENT_AVSESSIONS: "County",
      TNT_USERSPERSESSION: "Sub County",
      constituency: "Constituency",
      schoollevel: "Institution Level",
      school_category_id: "Application Type",
      applicationtype: "School Category",
      TNT_STATUS: "Status",
      sne_category_id: "Integrated Categories",
      sne_subcategory_id: "Sub Categories",
    };
    return fieldNames[fieldName] || fieldName;
  }

  updateInstitution() {
    this.isUpdating = true;
    this.activeSpinner();

    this.calculateTotalLearners();

    const payload: any = {
      TNT_NAME: this.editData.TNT_NAME || "",
      TNT_STATUS: true,
      TNT_MODIFIEDBY: this.userId,
      TNT_DESCRIPTION: this.editData.TNT_DESCRIPTION || "",
      accommodation_type: this.editData.accommodation_type || "",
      email: this.editData.email || "",
      applicationtype: this.editData.applicationtype || "",
      schoollevel: this.editData.schoollevel || "",
      mobileno: this.editData.mobileno || "",
      institution_type: this.editData.institution_type || "",
      institution_level: this.editData.institution_level || "",
      tnt_boys_capacity: Number(this.editData.tnt_boys_capacity) || 0,
      tnt_girls_capacity: Number(this.editData.tnt_girls_capacity) || 0,
      tnt_sne_capacity: Number(this.editData.tnt_sne_capacity) || 0,
      tnt_sne_boyscapacity: Number(this.editData.tnt_sne_boyscapacity) || 0,
      tnt_sne_girlscapacity: Number(this.editData.tnt_sne_girlscapacity) || 0,
      registration_no: this.editData.registration_no || "",
      is_valid_certificate: this.editData.is_valid_certificate || false,
      tnt_registration_certificate:
        this.editData.tnt_registration_certificate || "",
      counties_id: this.editData.TNT_CONCURRENT_AVSESSIONS || 0,
      sub_counties_name: this.editData.TNT_USERSPERSESSION || "",
      con_counties_name: this.editData.constituency || "",
      landmark: this.editData.landmark || "",
      schoollocation: this.editData.schoollocation || "",
      latitude: this.editData.latitude || "",
      longitude: this.editData.longitude || "",
      school_regno: this.editData.school_regno || "",
      schoolnameincertificate: this.editData.schoolnameincertificate || "",
      TNT_CONCURRENT_AVSESSIONS: this.editData.TNT_CONCURRENT_AVSESSIONS || "",
      TNT_USERSPERSESSION: this.editData.TNT_USERSPERSESSION || "",
      subscriptionid: this.editData.subscriptionid || 35,
      gpi: this.editData.gpi || "0",
    };

    if (this.editData.school_category_id) {
      payload.school_category_id = this.editData.school_category_id;
    }

    if (this.selectedSneDetails && this.selectedSneDetails.length > 0) {
      payload.sne_category_id = this.selectedSneDetails
        .map((x: any) => x.SNE_CATEGORY_ID)
        .join(",");
    } else if (this.editData.sne_category_id) {
      payload.sne_category_id = this.editData.sne_category_id;
    }

    if (this.selectedSubSneDetails && this.selectedSubSneDetails.length > 0) {
      payload.sne_subcategory_id = this.selectedSubSneDetails
        .map((x: any) => x.SNE_SUBCATEGORY_ID)
        .join(",");
    } else if (this.editData.sne_subcategory_id) {
      payload.sne_subcategory_id = this.editData.sne_subcategory_id;
    }

    if (this.editData.TNT_CODE) {
      payload.TNT_CODE = this.editData.TNT_CODE;
    }

    this.CommonService.postCall(
      "TenantRegistration/UpdateTenantData",
      payload,
    ).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        this.isUpdating = false;
        this.toastr.success("Institution updated successfully!");

        // Refresh profile details and logo
        this.loadProfileLogo();

        $("#editInstitutionModal").modal("hide");
      },
      (error) => {
        this.deactivateSpinner();
        this.isUpdating = false;
        this.toastr.error(
          error.error?.message ||
            error.message ||
            "Failed to update institution. Please try again.",
        );
      },
    );
  }

  closeEditModal() {
    this.resetSneSelections();
    this.certificateFileToUpload = null;
    if (this.fileInputRef1) {
      this.fileInputRef1.nativeElement.value = "";
    }
  }

  resetSneSelections() {
    this.selectedSneDetails = [];
    this.selectedSubSneDetails = [];
    this.sneCategoriesList = [];
    this.subSneCategoriesList = [];
    this.showSubSneDropdown = false;
    this.originalSneDetails = [];
    this.originalSubSneDetails = [];
  }

  validateEmail(event: any): void {
    const val = event.target.value.trim();
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

    if (!emailPattern.test(val)) {
      this.editData.email = "";
      this.toastr.warning("Invalid Email, Please Input a Valid Email Address.");
      return;
    }

    const domain = val.split("@")[1];
    if (/\d/.test(domain)) {
      this.editData.email = "";
      this.toastr.warning(
        'Numbers are not allowed in the domain part of the email (after "@").',
      );
      return;
    }
  }

  checkEmail(event: any, ctrl: string = "") {
    if (!this.editData.email) return;

    this.activeSpinner();
    this.CommonService.postCall("TenantRegistration/GetTenantByEmail", {
      email: ctrl == "" ? event?.target.value : event,
    }).subscribe(
      (res: any) => {
        this.deactivateSpinner();
      },
      (e) => {
        if (e.error) {
          this.toastr.error(e.error.message || "Email Already Exists");
          this.editData.email = this.originalData.email || "";
        }
        this.deactivateSpinner();
      },
    );
  }

  // Logo Upload Methods
  changeFile(event: any) {
    if (event.target.files.length > 0) {
      let file: File = event.target.files[0];
      let name = file.name;
      let filetype = name.split(".").pop();
      let types: Array<any> = ["png", "jpg", "PNG", "jpeg", "gif", "JPEG"];
      let check = types.includes(filetype);
      if (check) {
        this.file = file;
        const reader = new FileReader();
        reader.onload = () => {
          this.previewUrl = reader.result;
        };
        reader.readAsDataURL(this.file);
      } else {
        alert("Please upload image file formats only.");
        event.target.value = "";
      }
    }
  }

  upload() {
    if (!this.file) return this.toastr.warning("Please Upload Logo");
    let base64String: any;
    var reader = new FileReader();
    let self = this;
    if (self.fileName == "" || self.fileName == null) {
      return this.toastr.warning("Please Upload Logo");
    }
    reader.onload = function () {
      base64String = reader.result;
      self.fileName = base64String;
      let payLoad = {
        TNT_CODE: localStorage.getItem("TenantCode"),
        Tnt_BaseLogo: self.fileName,
      };
      self.CommonService.postCall(
        "TenantRegistration/UploadTenantLogo",
        payLoad,
      ).subscribe(
        (res: any) => {
          self.toastr.success("Image Saved Successfully");
          self.loadProfileLogo();
        },
        (err) => {
          self.toastr.error(err.error ? err.error : "Image Not Updated");
        },
      );
    };
    reader.readAsDataURL(this.file);
  }

  getImage() {
    if (!this.fileName) return "";
    if (this.fileName.includes("data:image")) {
      return this.fileName;
    } else {
      return "data:image/png;base64," + this.fileName;
    }
  }

  closeProfileInfo() {
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = "";
    }
    this.file = null;
    this.fileName = "";
    this.previewUrl = null;
  }

  toggleIsExpanded() {
    this.sidebarStateService.toggleIsExpanded();
    if (this.isExpanded) {
      this.isWaterAnimationActive = false;
    } else {
      this.isWaterAnimationActive = true;
    }
  }

  loadingToggled() {
    $(function () {
      "use strict";

      $(".mobile-toggle-menu").on("click", function () {
        $(".body-wrapper").addClass("toggled");
      });

      $(".toggle-icon").click(function (e: any) {
        e.preventDefault();
        if ($(".body-wrapper").hasClass("toggled")) {
          $(".body-wrapper").removeClass("toggled");
          $(".sidebar-wrapper").unbind("hover");
        } else {
          $(".body-wrapper").addClass("toggled");
          $(".sidebar-wrapper").hover(
            function () {
              $(".body-wrapper").addClass("sidebar-hovered");
            },
            function () {
              $(".body-wrapper").removeClass("sidebar-hovered");
            },
          );
        }
      });
    });
  }

  Signout() {
    if (confirm("Are you sure you want to logout?")) {
      this.timeTracker();
      this.chatService.setMessages(null);
      this.clearToken();
      // this.logout();
      setTimeout(() => {
        localStorage.clear();
        sessionStorage.clear();
        if (this.ROLEID == "2115" || this.ROLEID == "2116")
          this.route.navigate(["/vendorlogin"]);
        else this.route.navigate(["/login"]);
      }, 500);
    }
  }
  // logout() {
  //   const chatbotDynamicUrl: string =
  //     location.href.includes("https://bedev.samvaadpro.com") ||
  //     location.href.includes("http://localhost")
  //       ? "https://helpdesk-pro.dhanushinfotech.com/chatbot"
  //       : location.href.includes("https://kemis.go.ke")
  //         ? "https://helpdesk.kemis.go.ke/chatbot/enc"
  //         : "https://kemis-helpdesk-pro.dhanushinfotech.com/chatbot/enc";
  //   const iframe = document.getElementById("chatbotFrame") as HTMLIFrameElement;

  //   iframe?.contentWindow?.postMessage({ action: "logout" }, chatbotDynamicUrl);

  //   sessionStorage.clear();
  //   localStorage.clear();
  // }
  clearToken() {
    this.CommonService.postCall("Account/ClearToken", {
      UserID: localStorage.getItem("UserId"),
    }).subscribe((res: any) => {});
  }

  menuClick() {
    $("#sidebar").toggleClass("slide");
  }

  loadMessage() {
    this.notifications = [];
    if (this.ROLEID == "1") {
      this.OPERATION = "GETNOTIFICATIONS";
    } else if (this.ROLEID == "2") {
      this.OPERATION = "TRAINERNOTIFICATIONS";
    } else if (this.ROLEID == "3") {
      this.OPERATION = "STUDENTNOTIFICATIONS";
    }

    this.CommonService.getCall(
      `Notification/GetNotification/${this.OPERATION}/${localStorage.getItem(
        "TenantCode",
      )}/${localStorage.getItem("UserId")}`,
    ).subscribe(
      (res: any) => {
        this.notification = res;
      },
      (e) => {
        console.log(e);
      },
    );
  }

  loadNotification() {
    this.notification = [];
    this.CommonService.getCall(
      `EmsAlerts/GetNotificationsByUser/${localStorage.getItem("UserId")}`,
    ).subscribe((res: any) => {
      this.notification = res?.lstt;
      this.notificationCount = res;
    });
  }

  viewNotification(event: any) {
    this.viewNoti = [];
    this.viewNoti =
      +event == 0
        ? this.notification
        : this.notification.filter((e: any) => e.ID == event);

    this.CommonService.getCall(
      `Notification/UpdateNotification/UPDATE/${event}`,
    ).subscribe((res: any) => {});
    let payload = {
      user_id: localStorage.getItem("UserId"),
      notification_id: event,
      is_read: true,
      tnt_code: localStorage.getItem("TenantCode"),
      createdby: localStorage.getItem("UserId"),
      modifiedby: localStorage.getItem("UserId"),
    };
    this.CommonService.postCall(
      "EmsAlerts/CreateReadMessages",
      payload,
    ).subscribe((res: any) => {});
  }

  getOnlineTeachers(TenantCode: number) {
    [this.TeachersCount, this.onlineTeachers] = [0, []];
    this.CommonService.getData(
      `telecon/doctorstatus/getall/?TENANT_ID=${TenantCode}`,
    ).subscribe((res) => {
      [this.onlineTeachers, this.TeachersCount] = [res, res.length];
    });
  }

  viewMessage(event: any) {
    this.viewNoti = [];
    this.viewNoti =
      +event == 0
        ? this.notification
        : this.notification.filter((e: any) => e.ID == event);
  }

  delete(id: any, type: any, notificationid: any) {
    if (id) {
      type = 2;
    } else if (notificationid) {
      type = 1;
    }
    return;
  }

  close() {
    this.getUnViewdNotificationCount();
    this.loadMessage();
  }

  close1() {
    this.myForm.reset();
  }

  getOldPassword() {
    this.CommonService.postCall(`Registration/GetOldPassWord`, {
      userid: localStorage.getItem("UserId"),
    }).subscribe((res: any) => {
      this.oldPassword = res.password;
    });
  }

  passwordCheck() {
    let pControl = this.myForm.controls["password"];
    let cControl = this.myForm.controls["confirmPassword"];
    if (!pControl.value) {
      this.toastr.warning("Please enter the password");
      cControl.setValue(null);
      return;
    }
    if (pControl.value != cControl.value) {
      this.toastr.warning("New Password and Confirm Password Should be same");
      cControl.setValue(null);
    }
  }

  async ChangePass(form: any) {
    let value = form.value;

    const encryptedPassword = await this.CommonService.encryptAesGcm(
      value.password.toString(),
      this.CommonService.secretKey,
    );

    let payload = {
      userid: localStorage.getItem("UserId"),
      password: encryptedPassword,
    };
    if (this.oldPassword == value.oldPassword) {
      this.CommonService.postCall(
        `Registration/UpdateUserPassWord`,
        payload,
      ).subscribe(
        (res: any) => {
          this.toastr.success("Password Changed Successfully");
          document.getElementById("passPopupClose")?.click();
          this.Signout();
        },
        (err) => {
          this.toastr.error(err.error ? err.error : "Password Not Changed");
        },
      );
    } else {
      this.toastr.warning("Old Password is Incorrect");
    }
  }

  getUnViewdNotificationCount1() {
    return this.table.filter((m) => m.IsRead == false).length;
  }

  getUnViewdNotificationCount() {
    return this.notification?.length;
  }

  apply() {
    document.getElementById("Noti_close")?.click();
  }

  userManual() {
    window.open(
      `${environment.videoUrl}/home/userManual/Student_Process_Flow.docx`,
    );
  }

  profileNavigate(role: any) {
    let id = localStorage.getItem("UserId");
    sessionStorage.isTabsDisabled = false;
    this.CommonService.postCall("EditRegistrationByUserId", {
      CREATEDBY: id,
    }).subscribe(
      (res: any) => {
        if (role == "admin") {
          this.route.navigate(["HOME/registration/editUserRegistration"], {
            queryParams: { token: res.value, wId: 64, rId: 2071 },
          });
        } else {
          this.route.navigate(["HOME/registration/profile"]);
        }
      },
      (err) => {},
    );
  }

  viewMessages(event: any) {}
  viewNotifications(event: any) {}

  timeTracker() {
    this.startTime = localStorage.getItem("loginTime");
    let Sdate: any = new Date(this.startTime);
    const timestamp = Sdate.toLocaleTimeString();

    this.endtime = new Date();
    this.getDataDiff(Sdate, this.endtime);

    let payload = {
      loginaudit_userid: localStorage.getItem("UserId"),
      loginaudit_login_intime: timestamp,
      loginaudit_login_outtime: this.endtime.toLocaleTimeString(),
      loginaudit_login_timespent: `${this.differnceTime.hour}:${this.differnceTime.minute}:${this.differnceTime.second}`,
      loginaudit_createdby: localStorage.getItem("UserId"),
      tnt_code: localStorage.getItem("TenantCode"),
    };
    this.CommonService.postCall("LoginAudit/CreateAudit", payload).subscribe(
      (res: any) => {},
    );
  }

  getDataDiff(startDate: any, endDate: any) {
    let diff = endDate.getTime() - startDate.getTime();
    let days = Math.floor(diff / (60 * 60 * 24 * 1000));
    let hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
    let minutes =
      Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);
    let seconds =
      Math.floor(diff / 1000) -
      (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
    this.differnceTime = {
      day: days,
      hour: hours,
      minute: minutes,
      second: seconds,
    };
  }

  getRoles() {
    let payload = {
      USERID: localStorage.getItem("UserId"),
      TENANTCODE: localStorage.getItem("TenantCode"),
    };
    this.CommonService.postCall(
      "Registration/LoadRolesDashboard",
      payload,
    ).subscribe((res: any) => {
      this.roles = res;
    });
  }

  changeRoles(event: any) {
    let val = event.target.value;
    let payload = {
      USERID: localStorage.getItem("UserId"),
      TENANTCODE: localStorage.getItem("TenantCode"),
      ROLEID: val,
    };
    this.CommonService.postCall(
      "Registration/LoadRolesByUser",
      payload,
    ).subscribe(
      (res: any) => {
        let userData: any = res[0];
        localStorage.setItem("RoleId", btoa(val));
        sessionStorage.setItem("RoleId", btoa(val));
        localStorage.setItem("SchoolId", userData.CATEGORY_ID);
        localStorage.setItem("DepartmentId", userData.DEPARTMENT_ID);
        localStorage.setItem("TYPE", userData.TYPE);
        localStorage.setItem("RoleName", userData.ROLE_NAME);
        this.roleName = userData.ROLE_NAME;
        this.roleChange(val);
      },
      (err: any) => {
        this.toastr.error("Failed!");
      },
    );
  }

  getSchool() {
    this.CommonService.getCall(
      "Registration/GetActiveSchoolLevelList",
    ).subscribe((res: any) => {
      this.SchoolList = res;
    });
  }

  changeSchool(event: any) {
    this.CommonService.activateSpinner();
    let val = event.target.value;
    let payload = {
      UserId: localStorage.getItem("UserId"),
      SCHOOLLEVEL: val,
    };
    this.CommonService.postCall(
      "Registration/UpdateSchoolLevelId",
      payload,
    ).subscribe(
      (res: any) => {
        localStorage.setItem("schoolLevelID", val);
        this.RouteToDashboard();
        this.CommonService.deactivateSpinner();
      },
      (err: any) => {
        this.toastr.error("Failed!");
        this.CommonService.deactivateSpinner();
      },
    );
  }

  RouteToDashboard() {
    const navigationExtras: any = {
      queryParams: {
        cd: true,
        reload: "true",
        timestamp: Date.now(),
      },
      queryParamsHandling: "merge",
    };

    if (this.ROLEID == "2128") {
      this.route.navigate(["/HOME/cdeDashboard"], navigationExtras);
    } else if (this.ROLEID == "2127") {
      this.route.navigate(["/HOME/scdeDashboard"], navigationExtras);
    } else if (this.ROLEID == "2129") {
      this.route.navigate(["/HOME/qasoDashboard"], navigationExtras);
    } else if (this.ROLEID == "2145") {
      this.route.navigate(["/HOME/rdeDashboard"], navigationExtras);
    } else {
      this.route.navigate(["/HOME/dashboard"], navigationExtras);
    }
  }

  getAccessingText(): string {
    return this.SchoolLevelId == 6
      ? "You are Currently accessing Primary School Information"
      : "You are Currently accessing Senior School Information";
  }

  roleChange(rId: any) {
    this.CommonService.activateSpinner();
    this.CommonService.getCall(
      `PermissionRole/GetListById/${localStorage.TenantCode}/${+rId}`,
    ).subscribe(
      (res: any) => {
        localStorage.removeItem("isApprove");
        localStorage.setItem("isApprove", btoa(JSON.stringify(res.data)));
        this.superMaduleEvent.emit(rId);
        this.route.navigate(["/HOME"], { queryParams: { req: rId } });
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
      },
    );
  }

  isUrlBasedLogo(): boolean {
    return localStorage.getItem("isUrlBasedLogo") === "true";
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG and PNG files allowed");
      event.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result;
    };
    reader.readAsDataURL(file);
  }

  navigateToDashboard() {
    this.route.navigate([this.dashboardPath]);
  }

  activeSpinner() {
    this.CommonService.activateSpinner();
  }

  deactivateSpinner() {
    this.CommonService.deactivateSpinner();
  }
}
